export const DRIVER = 'driver';
export const DISPATCHER = 'dispatcher';
export const ADMIN = 'admin';
export const RECIPIENT = 'recipient';
export const CUSTOMER = 'customer';
